import callApi, { ENDPOINTS } from 'utils/api/callApi'

interface IUpdateDetentionResponse {
  ok: boolean
}

interface IUpdateDetentionBody {
  rejectionReason: string
}

/**
 * Accepts or rejects a pending detention accessorial
 * @method POST
 * @param {string} accessorialId
 * @param {string} group // Detention Dialog state
 * @param {string} body // Optional rejection reason
 */
export const updateShipmentAccessorials = (
  accessorialId: string,
  group: 'reject' | 'approve',
  body?: IUpdateDetentionBody
): Promise<IUpdateDetentionResponse> => {
  return callApi({
    endpoint: ENDPOINTS.shipmentAccessorials,
    method: 'POST',
    group: `${accessorialId}/${group}`,
    body,
  })
}
